// import findIndex from 'lodash/findIndex';
import moment from 'moment-timezone';
import { constantCreator } from '~/utils/constantsCreator';

const constant = constantCreator('toast');
const sessionConstant = constantCreator('session');
const tripConstant = constantCreator('trip');
const CLOSE_TOAST = constant('CLOSE_TOAST');
const OAUTH_LOGIN_SUCCESS = constant('OAUTH_LOGIN_SUCCESS');
const PUSH_REDEEM_REMINDER = constant('PUSH_REDEEM_REMINDER');
const CLICK_TOAST = constant('CLICK_TOAST');

const LOGIN = sessionConstant('LOGIN', true);
const SIGNUP = sessionConstant('SIGNUP', true);

const CUSTOMIZE_QTY = tripConstant('CUSTOMIZE_QTY', true);

moment.tz.setDefault('Asia/Bangkok');

const initialState = {
  show: false,
  message: '',
  type: '',
  toasts: [],
  instantPushed: false,
  verifyEmailPushed: false,
  messages: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CLOSE_TOAST: // eslint-disable-line
      const index = state.toasts.findIndex(t => t.id === action.id);
      if (index < 0) {
        return state;
      }
      const toasts = [
        ...state.toasts.slice(0, index),
        { ...state.toasts[index], closed: true },
        ...state.toasts.slice(index + 1),
      ];
      return {
        ...state,
        toasts,
      };
    case PUSH_REDEEM_REMINDER:
      return {
        ...state,
        toasts: [
          ...state.toasts,
          {
            type: 'redeem',
            timeout: 0,
            id: action.code,
            percentage: action.percentage,
            constant: action.constant,
            currency: action.currency,
            expires_at: action.expires_at,
            code: action.code,
          }]
      };
    case LOGIN.RESOLVED:
    case SIGNUP.RESOLVED:
    case OAUTH_LOGIN_SUCCESS:
      return {
        ...state,
        toasts: [
          ...state.toasts,
          {
            message: 'Logged in successfully',
            type: 'success',
            timeout: 3000,
            id: Math.random().toString(36).substring(7),
          },
        ],
      };
    case CUSTOMIZE_QTY.PENDING:
      return {
        ...state,
        toasts: [
          ...state.toasts,
          {
            message: 'You’re sending a booking request. We’ll contact you back within 24 hours',
            type: 'success',
            timeout: 5000,
            id: Math.random().toString(36).substring(7),
          },
        ],
      };
    // case DUMP_TRANSLATED_MESSAGES:
    //   return {
    //     ...state,
    //     messages: action.messages
    //   };
    // case LOAD_COMBINED_STATIC_SUCCESS:
    //   const toastMessages = Object.keys(action.result.translations).filter((k)=> k.startsWith('toast'));
    //   return {
    //     ...state,
    //     messages: pick(action.result.translations, toastMessages)
    //   };
    // case CONFIRM_BOOKING_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.booking_confirmed'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case CONFIRM_MOBILE_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.mobile_verified'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case DUPLICATE_LISTING_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.listing_duplicated'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case LOGIN_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.logged_in'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case RESCHEDULE_BOOKING_SUCCESS:
    //   const resMessage = !action.days || action.days.length < 1 ? state.messages['toast.trip_canceled'] : state.messages['toast.booking_rescheduled'];
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: resMessage, type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case RESCHEDULE_BOOKING_FAIL:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: action.error.message, type: 'warning', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case RESPOND_BOOKING_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: action.date ? state.messages['toast.new_trip_date_selected'] : state.messages['toast.trip_canceled'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case REQUST_SUGGESTED_TRIP_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.request_sent'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case SAVE_AVAIL_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.availability_updated'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case SEND_EMAIL_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.confirm_email_sent'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case SEND_SMS_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.sms_sent'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case SUBMIT_LX_CANCEL_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.trip_canceled'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case SUBMIT_CUSTOMIZE_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Submitted, we will contact you as soon as posible.', type: 'success', timeout: 7000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case UPDATE_PROFILE_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.profile_updated'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case UPDATE_BOOKING_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.trip_updated'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case UPDATE_LISTING_SUCCESS:
    //   if (action.hideToast) return state;
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.save_draft'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case SUBMIT_LISTING_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.submit_listing'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case UPLOAD_TRIP_IMAGE:
    // case SUBMIT_PAYMENT_CODE_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Successfully submitted', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case RELEASE_PAYMENT_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Payment released, please help us give a review.', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case HOLD_PAYMENT_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Payment has been held, we will contact you shortly.', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case PUSH_TOAST:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: action.notification.text, type: 'noti',
    //       timeout: 5000, id: Math.random().toString(36).substring(7),
    //       sender_id: action.notification.sender_id,
    //       link: action.notification.path,
    //       is_admin: action.notification.type}]
    //   };
    // case PUSH_REDEEM_REMINDER:
    //   return {
    //     ...state,
    //     toasts: [
    //       ...state.toasts,
    //       {
    //         type: 'redeem',
    //         timeout: 0,
    //         id: action.code,
    //         percentage: action.percentage,
    //         constant: action.constant,
    //         currency: action.currency,
    //         expires_at: action.expires_at,
    //         code: action.code,
    //       }]
    //   };
    // case COPY_LINK_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.copy_link'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // case PUSH_VERIFY_EMAIL:
    //   return {
    //     ...state,
    //     verifyEmailPushed: true,
    //     toasts: [...state.toasts, {message: state.messages['toast.verify_email'], type: 'warning', timeout: 5000, id: Math.random().toString(36).substring(7), link: '/dashboard/verification'}]
    //   };
    // case REPLY_REVIEW_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: state.messages['toast.reply_review'], type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    //   };
    // // case SUBMIT_DIGI:
    // //   return {
    // //     ...state,
    // //     toasts: [...state.toasts, {message: 'Form submitted', type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    // //   };
    // // case SUBMIT_PEER_REVIEW_SUCCESS:
    // //   return {
    // //     ...state,
    // //     toasts: [...state.toasts, {message: 'Review submitted', type: 'success', timeout: 3000, id: Math.random().toString(36).substring(7)}]
    // //   };
    // case PUSH_INSTANT:
    //   return {
    //     ...state,
    //     instantPushed: true,
    //     toasts: [
    //       ...state.toasts,
    //       {
    //         type: 'instant',
    //         timeout: 0,
    //         id: Math.random().toString(36).substring(7),
    //       }]
    //   };
    default:
      return state;
  }
}

export const actions = {
  closeToast: id => ({
    type: CLOSE_TOAST,
    id,
  }),
  oauthLoginSuccess: () => ({
    type: OAUTH_LOGIN_SUCCESS
  }),
  logClickToast: (toastType, code = null) => ({
    type: CLICK_TOAST,
    toastType,
    code,
  }),
  pushBlackFridayRedeem: () => ({
    type: PUSH_REDEEM_REMINDER,
    code: 'BLACKFRI17',
    percentage: 0.17,
    expires_at: '2017-11-19T16:55:00.000',
  }),
  closeBlackFridayToast: () => ({
    type: CLOSE_TOAST,
    id: 'BLACKFRI17',
    noLog: true
  })
};
export const analytics = {
  // [PUSH_REDEEM_REMINDER]: action => (action.noAnalytic ? null : { name: 'Push Info Toast', category: 'Toast', toastType: 'promo_code', code: action.code }),
//   [PUSH_INSTANT]: () => ({name: 'Push Info Toast', category: 'Toast', toastType: 'instant_tomorrow'}),
  [CLICK_TOAST]: action => ({
    name: 'Click Toast', category: 'Toast', toastType: action.toastType, code: action.code
  }),
  [CLOSE_TOAST]: action => (action.noLog ? null : ({ name: 'Close Toast', category: 'Toast', toastId: action.id }))
};

// export function closeToast(id) {
//   return {
//     type: CLOSE_TOAST,
//     id,
//   };
// }
// export function logClickToast(toastType, code = null) {
//   return {
//     type: CLICK_TOAST,
//     toastType,
//     code,
//   };
// }
// export function pushNotification(notification) {
//   return {
//     type: PUSH_TOAST,
//     notification
//   };
// }

// export function pushRedeemReminder(redeem) {
//   return {
//     type: PUSH_REDEEM_REMINDER,
//     code: redeem.code,
//     percentage: redeem.percentage,
//     constant: redeem.constant,
//     currency: redeem.currency,
//     expires_at: redeem.expires_at,
//   };
// }

// export function pushInstant() {
//   return {
//     type: PUSH_INSTANT,
//   };
// }

// export function pushVerifyEmail() {
//   return {
//     type: PUSH_VERIFY_EMAIL,
//   };
// }
